import React from "react";
import SelectInput from "../widgets/SelectInput";
import getCorsi from "../services/getCorsi";
import Cookies from "universal-cookie";
import FixButton from "./Button";
import updateCambioCorsoStudente from "../services/updateCambioCorsoStudente";
import setSospensioneStudente from "../services/setSospensioneStudente";

export default class CambioClasseWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      corsiPerRecupero: [],
      selectedCorso: null,
      isSaving: false,
      mantieniAssenze: true, // Default: mantieni le assenze
    };
  }

  componentDidMount() {
    this.getClassiCorso();
  }

  getClassiCorso() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const corsoId = cookies.get("currentCourse", { path: "/" });

    getCorsi(username, token)
      .then((corsi) => {
        this.setState({
          corsiPerRecupero: corsi,
        });
      })
      .catch((error) => {
        console.error("Error fetching corsi:", error);
      });
  }

  async salvaCambioClasse() {
    const cookies = new Cookies();
    const username = cookies.get("username", { path: "/" });
    const token = cookies.get("token", { path: "/" });
    const id_studente = this.props.studente;
    const id_corso_precedente = this.props.idCorsoAttuale;
    const id_corso_nuovo = this.state.selectedCorso.value;
    const mantieni_assenze = this.state.mantieniAssenze;

    console.log("🔄 [CambioClasseWidget] Inizio cambio corso:", {
      id_studente,
      id_corso_precedente,
      id_corso_nuovo,
      mantieni_assenze,
      studente: this.props.studente,
    });

    try {
      this.setState({ isSaving: true });

      const response = await updateCambioCorsoStudente(
        username,
        token,
        id_studente,
        id_corso_precedente,
        id_corso_nuovo,
        mantieni_assenze
      );

      // Riattiva lo studente: disabled = 0 e data_sospensione = NULL
      // (lo studente viene spostato in un nuovo corso, quindi non è più sospeso)
      await setSospensioneStudente(username, token, id_studente, 0);

      console.log("✅ [CambioClasseWidget] Risposta ricevuta:", response);
      alert("Cambio classe effettuato con successo!");

      // Ricarica la pagina per vedere i cambiamenti
      window.location.reload();
    } catch (err) {
      console.error("❌ [CambioClasseWidget] Errore:", err);
      alert("Errore durante il cambio classe: " + err.message);
    } finally {
      this.setState({ isSaving: false });
      this.props.onClose();
    }
  }

  render() {
    return (
      <div style={cardClass}>
        <div style={closeIcon} onClick={() => this.props.onClose()}>
          X
        </div>
        <div className="windowTitle" style={{ color: "black" }}>
          Cambio Classe
        </div>
        <div style={{ marginTop: "10px", textAlign: "center" }}>
          {(this.props.studente?.cognome || "") +
            " " +
            (this.props.studente?.nome || "")}
        </div>

        <SelectInput
          style={{ marginTop: "20px" }}
          options={
            this.state.corsiPerRecupero.map((c) => ({
              value: c.id,
              label: c.name,
            })) ?? []
          }
          onChange={(val) => {
            this.setState({ selectedCorso: val });
          }}
          value={this.state.selectedCorso}
          placeholder="Seleziona una classe"
        />

        {/* Checkbox per mantenere/azzerare le assenze */}
        <div style={{ marginTop: "20px", textAlign: "left" }}>
          <label
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <input
              type="checkbox"
              checked={this.state.mantieniAssenze}
              onChange={(e) =>
                this.setState({ mantieniAssenze: e.target.checked })
              }
              style={{
                marginRight: "8px",
                cursor: "pointer",
                width: "18px",
                height: "18px",
              }}
            />
            <span style={{ fontSize: "14px" }}>
              Mantieni le assenze dal corso precedente
            </span>
          </label>
          <div
            style={{
              fontSize: "12px",
              color: "#666",
              marginTop: "5px",
              marginLeft: "26px",
            }}
          >
            {this.state.mantieniAssenze
              ? "✓ Le assenze non recuperate saranno spostate nel nuovo corso"
              : "✗ Le assenze del corso precedente saranno azzerate"}
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px", marginTop: "20px" }}>
          <FixButton
            title="Salva"
            disabled={!this.state.selectedCorso || this.state.isSaving}
            callback={() => this.salvaCambioClasse()}
          />
          <FixButton title="Annulla" callback={() => this.props.onClose()} />
        </div>
      </div>
    );
  }
}

const cardClass = {
  position: "fixed",
  left: "45%",
  top: "20%",
  background: "#ffffff",
  border: "1px solid black",
  padding: "20px",
  overflow: "scroll",
  zIndex: 999,
};

const closeIcon = {
  position: "absolute",
  cursor: "pointer",
  right: 0,
  top: 0,
  padding: 10,
};
